import { Component, OnInit} from '@angular/core';
import { NavigationStart, Router } from '@angular/router';
import { SwUpdate } from '@angular/service-worker';
import { CheckForUpdatesService } from './services/check-for-updates.service';
import { AlertController } from '@ionic/angular';
import { Subscription} from 'rxjs'



@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss'],
})
export class AppComponent  implements OnInit{

  
subscription:Subscription;

  constructor(
    private checkForUpdateService:CheckForUpdatesService,
    private updates:SwUpdate,
    private router:Router,
    public alertController: AlertController
    ) { 
      this.subscription = router.events.subscribe((event) => {
        if (event instanceof NavigationStart) {
          //this.presentAlert();
        }
      });
    }

  ngOnInit():void{

  //this.pageRefresh();

    // if updates are supported by the browser
    if (this.updates.isEnabled) {
      this.checkForUpdateService;
      this.updates.available.subscribe(event => {
        console.log('new version avail!');
        this.updates.activateUpdate().then(() => {
          
         
          window.location.reload();
         
         
          
        })

      });

     this.updates.activated.subscribe(event=>{
      this.router.navigate(['/']);
     })
    }
  }

  async presentAlert() {
    const alert = await this.alertController.create({
      cssClass: 'my-custom-class',
      header: 'Alert',
      subHeader: 'Upate',
      message: 'A new update is avaiaable',
      buttons: ['OK']
    });

    await alert.present();
    alert.onDidDismiss().then(()=>{
      this.subscription.unsubscribe();
      
    })
   
  }

  

  
}
